export default __webpack_public_path__ + "static/media/halo-icon.0d9b42fd.svg";